import { createMuiTheme } from "@material-ui/core/styles";

//Note: Add common color in defaultThemeStyles only when it is independent on all themes
const defaultThemeStyles = {
  dispatchCardTextFontSize: 10,
  textFontSize: 12,
  textFontSize_13: 13,
  headerTextFontSize: 14,
  headerTextFontSize16: 16,
  headerTextFontSize24: 24,
  overrides: {
    MuiSvgIcon: {
      root: {
        fontSize: 16,
      },
    },
    MuiButton: {
      root: {
        textTransform: "none",
      },
    },
    MuiSnackbarContent: {
      message: {
        fontWeight: 600,
      },
    },
  },
  HeaderBGColor: "#171D2B",
  radioDisabledText: '#C0C0C0',
  notificationColor: '#bfbfbf',
  printTableLabel: "#000000",
  printTableValue: "#444444",
  printTableBorder: "#d7d7d7",
  noStopErrorBGColor: '#FAFAD6',
  disabledColor: "#808080",
  borderColor: "#D8D8D8",
  tableRowRootBackground: "#F0F0F0",
  dropAnchorPointBtn: '#E4485B',
  anchorPointBtnBorder: '#CF3F50',
  delayStatusHeadColor: "#F8D9D9",
  error: "#CF0000",
  avatarBorderColor: "#8493A3",
  lastRefreshColorBGColor: "#FFECB3",
  lastRefreshTextColor: "#D69900",
  statusWrapperHighlightedColor: "#F8D9D9",
  AnchorBGColor: "#CDCDCD",
  warningBGColor: "#FFDCA8",
  messageTextColor: "#000000",
  sendMessageBGColor: "#e3e3e3",
  replyMessageBGColor: "#C5DBEE",
  chatWaitingText: "#F2984E",
  ToggleDisableIconColor: "#979B9D",
  delayHeadColor: "#D03131",
  headFontColor: "#ffffff",
  chatMetadataColor: '#666',
  ErrorMessageColor: "#E2445C",
  rowViolationDotColor: "#D55A69",
  starIconColor: "#FFCA28",
  clickableLinkColor: "#B0E0E6",
  infoBGColor: "#C3DEDC",
  errorBGColor: "#EF9A9A",
  errorBGColorSecondary: "#EFD3D2",
  warningTextColor: "#E65100",
  errorTextColor: "#9E0000",
  recommendationCardStatusTextColor: "#8493A3",
  errorBorderColor: "#f44336",
  inputWarningLabelColor: "#F3C03E",
  warningTextColorDispatch: "#D69900",
  dividerColor: "#E5E5E5",
  urgentColor: "#F2A93B",
  printTableHead: "#F7F7F7",
  SelectedStopBorderColor: "#FF0000",
  closingTimeAlertBGColor : "#F9EFF0",
  closingTimeWarningBGColor : "#FAEDCF",
  loaderBgColorTranslucent:"rgba(128, 128, 128, 0.2)", //opacity added intentionally
  notificationLinkColor: "#44A8EE",
  hazmatSubheader: "#599AE5",
  emptyTrailerBorder:"#808080",
  dispatchShipperTextColor : "#30A3A0",
  trailerExtraBillsColor: "#F3A628",
  warningColor: "#E5A70D",
  delayedStopMarkerColor: "#F22929",
  white: "#FFFFFF",
  deviationStopColor: "#FC8596",
  selectedStopMarkerColor: "#FFFFFF",
  stopNameColor: "#1885FF",
  satelliteViewRouteColor: "#FFFFFF",
  driverLabelBG: "#0C6BB9",
  //snackbarNotification colors----
  snackbarSuccessBG: "#B3E5FC",
  snackbarSuccessTextColor: "#021512",
  snackbarErrorBG: "#FCBEB9",
  snackbarErrorTextColor: "#1A1104",
  snackbarWarningBG: "#FFDCA8",
  snackbarWarningTextColor: "#180705",
  snackBarCloseIcon: '#081208',
  //snackbarNotification colors end----
  gradientPrimaryColor: "#2484D1",
  gradientSecondaryColor: "#47a9f6",
  unassignPickupFillColor: "#E5A70D",
};

const modernLightThemeStyles = {
  ...defaultThemeStyles,
  themeName: "modernLight",
  AppBGColor: "#D9D9D9",
  HeaderDefaultTextColor: "#CCCCCC",
  ColumnHeaderTextColor: "#4D4D4D",
  ComponentHeader: "#ffffff",
  iconColor: "#666666",
  headerIconColor: "#CCCCCC",
  headerBorderColor: "#636363",
  disableButtonBG: "#A1A8B3",
  disableButtonText: "#444444",
  MapDrawingColor: "#898989",
  gridIconBorderColor: "#929292",
  ModalBGColor: "#FFFFFF",
  TextColor: "#000000",
  scrollThumbColor: "#CCCCCC",
  HighlightColor: "#BAD0E2",
  tooltipBGColor: "#EFEFEE",
  tooltipText: "#3E3E3E",
  tooltipBorderColor: "#7D7D7E",
  tooltipShadowColor: "#CBCBD1",
  menuHeaderBGColor: "#e2edf7",
  gridTextColor: "#666666",
  loadingBGColor: "#f7f7f7",
  gridBGColor: "#FFFFFF",
  terminalContentColor: "#000000",
  trailerBackgroundColor: "#F0F0F0",
  trailerBorderColor: "#ACADA9",
  popupLeftColColor: "#8493A3",
  subHeaderTextColor: "#525F6D",
  completeStopText: "#525F6D",
  stopsStatusBGColor: "#F7F8F9",
  stopsStatusSuccessBGColor: "#e2edf7",
  gridGroupHeaderBorderColor: "#D9D9D9",
  dispatchPanelHeaderColor: "#666666",
  dispatchPanelLabelValueColor: "#444444",
  deviationStopPopupColor: "#E84259",
  actualRouteColor: "#666666",
  disabledTextBG: "#F0F0F0",
  disabledGridRow : "#DBDBDB",
  address: '#D8D6D6',
  gridHeaderBGColor: "#F1F2F4",
  gridHeaderFontColor: "#10141d",
  shadowColor: "#BFBFBF",
  KPI: {
    KPISingleValue: "#0C6BB9",
    KPILabel: "#61646B",
    KPIPositive: "#357B38",
    KPINegative: "#C8372C",
    KPIGoalValue: "#272B34",
    KPIDivider: "#E5E5E5",
    KPIButton: "#D7D7D7",
  },
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: "#0C6BB9",
    },
    secondary: {
      main: "#282c34",
    },
  },
  routeMapColorPalette: {
    IconsColors: [
      "#C41A76",
      "#7220C8",
      "#00636C",
      "#B22811",
      "#FF7800",
      "#2B20AA",
      "#3C3B3B",
      "#DA75AC",
      "#A223D5",
      "#30B845",
      "#ED5146",
      "#44A8EE",
      "#099B95",
      "#82493F",
      "#FF288A",
      "#44BE9E",
      "#086DA7",
      "#E5A70D",
    ],
    MarkerBorderColor: "#ffffff",
    MarkerTextColor: "#ffffff",
  },
  AnchorTextColor: "#666666",
  trailerCardSelectedColor: "#EBEBEB",
  ModalHeaderTextColor: "#8493A3",
  StatusWrapperColor: "#e2edf7",
  chatBGColor: "#f6f6f6",
  StopIconColor : "#FFFFFF",
  customInputBGColor: "#666666",
  ToggleIconColor: "#0c6bb9",
  radioLabel: "#E6EFF6",
  activeRadioBG: "#e2edf7",
  radioLabelText: "#07406f",
  violationsBackgroundColor: "#CF00001A",
  searchBGColor: '#EBECEE',
  searchHoverBGColor: "#E5E5E5",
  groupHeaderParent: '#D9D9D9',
  messageHistoryBGHoverColor: "#ecf3f9",
  driverReportFilterBGColor: "#f9fafb",
  customMultiSelectColor: "#BAD0E2",
  commonAppHeaderTabColor: "#47a9f6",
  proNumberColor: "#0C6BB9",
  deviationGreenPopupColor: "#47a9f6",
  checkboxColor: "#0C6BB9",
  lightPrimaryColor: "#e2edf7",
  successTextColor: "#0C6BB9",
  infoTextColor: "#052b4a",
  HeaderSelectedText: "#0C6BB9",
  selectedRadioLabelText: "#07406f",
  quickFilterBGColor: '#f7f7f7',
  routeLockBGColor: '#e2edf7',
  headColor: '#0C6BB9',
  statusHeadFontColor: '#e2edf7',
  statusHeadBGColor: '#e2edf7',
  proNumbers: "#0C6BB9",
  mapPopupFooter: "#F0F0F0",
  maintenanceBGColor: "#edf6fd",
  btnHoverColor: "#E6EEF6",
  stopListCardStatusBar: '#E6E9EC',
  gridOverlayBGColor: "#F7F7F7",
  gridOverlayFontColor: "#10141D",
  //pickup marker colors start----
  markerStokeColor: "#FFFFFF",
  newPickupFillColor: "#0288D1",
  missedVoidedPickupFillColor: "#C8372C",
  pickupStatusFillColors: "#006B69",
  driverStatusMarkerColor: "#0C6BB9",
  //pickup marker colors end------
  quickFilterToggleButtonBorder: "#929292",
  dividerColorSecondary: "#D9D9D9",
  violationColor: "#C8372C",
  actionableTextColor: "#0C6BB9",
}

const modernDarkThemeStyles = {
  ...defaultThemeStyles,
  themeName: "modernDark",
  AppBGColor: "#000000",
  HeaderDefaultTextColor: "#CDCDCD",
  ColumnHeaderTextColor: "#FFFFFF",
  ComponentHeader: "#171D2B",
  iconColor: "#C0C0C0",
  headerIconColor: "#C0C0C0",
  headerBorderColor: "#313840",
  disableButtonBG: "#757C8D",
  disableButtonText: "#FFFFFF",
  MapDrawingColor: "#FFFFFF",
  gridIconBorderColor: "#C0C0C0",
  ModalBGColor: "#222a3f",
  TextColor: "#FFFFFF",
  scrollThumbColor: "#808080",
  HighlightColor: "#223f5c",
  tooltipBGColor: "#2C3740",
  tooltipText: "#FFFFFF",
  tooltipBorderColor: "#CDCDCD",
  tooltipShadowColor: "#7D7D7E",
  menuHeaderBGColor: "#223f5c",
  gridTextColor: "#CDCDCD",
  loadingBGColor: "#11161C",
  gridBGColor: "#171D2B",
  terminalContentColor: "#FFFFFF",
  trailerBackgroundColor: "#11161C",
  trailerBorderColor: "#FFFFFF",
  popupLeftColColor: "#A3A3A3",
  subHeaderTextColor: "#FFFFFF",
  completeStopText: "#C0C0C0",
  stopsStatusBGColor: "#11161C",
  stopsStatusSuccessBGColor: "#263955",
  gridGroupHeaderBorderColor: "transparent",
  dispatchPanelHeaderColor: "#C0C0C0",
  dispatchPanelLabelValueColor: "#C0C0C0",
  deviationStopPopupColor: "#E53E4E",
  actualRouteColor: "#FFFFFF",
  disabledTextBG: "#11161C",
  disabledGridRow : "#6c6f74",
  address: '#FFFFFF',
  gridHeaderBGColor: "#0D1017",
  gridHeaderFontColor: "#ffffff",
  shadowColor: "#2C3740",
  KPI: {
    KPISingleValue: "#00A7E1",
    KPILabel: "#B9BBBF",
    KPIPositive: "#75C178",
    KPINegative: "#F76E64",
    KPIGoalValue: "#FFFFFF",
    KPIDivider: "#E5E5E5",
    KPIButton: "#D7D7D7",
  },
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: "#47a9f6",
    },
    secondary: {
      main: "#ffffff",
    },
  },
  routeMapColorPalette: {
    IconsColors: [
      "#FF9897",
      "#FFA640",
      "#FFE339",
      "#B9FF00",
      "#FFDBA3",
      "#0094B4",
      "#B1D7FF",
      "#A97BFF",
      "#FF7BEC",
      "#FF403B",
      "#B9FF00",
      "#00E7C3",
      "#98A8FF",
      "#E6B0FF",
      "#FF7F00",
      "#FF6562",
      "#19FF70",
    ],
    MarkerBorderColor: "#212121",
    MarkerTextColor: "#212121",
  },
  AnchorTextColor: "#090F1E",
  trailerCardSelectedColor: "#2F3740",
  ModalHeaderTextColor: "#C0C0C0",
  StatusWrapperColor: "#263955",
  chatBGColor: "#353E48",
  StopIconColor : "#1D2630",
  customInputBGColor: "#808080",
  ToggleIconColor: "#47a9f6",
  radioLabel: "#25344D",
  activeRadioBG: "#2B486B",
  radioLabelText: "#91cbfa",
  selectedRadioLabelText: "#91CBFA",
  radioIconColor: "#C0C0C0",
  violationsBackgroundColor: "#F79DA0",
  searchBGColor: '#2C313E',
  searchHoverBGColor: "#1B283B",
  groupHeaderParent: '#1D2630',
  messageHistoryBGHoverColor: "#1c283a",
  driverReportFilterBGColor: "#1b2131",
  customMultiSelectColor: "#223f5c",
  commonAppHeaderTabColor: "#47a9f6",
  proNumberColor: "#47a9f6",
  deviationGreenPopupColor: "#0C6BB9",
  checkboxColor: "#47a9f6",
  lightPrimaryColor: "#223f5c",
  successTextColor: "#47a9f6",
  infoTextColor: "#b3e5fc",
  HeaderSelectedText: "#47a9f6",
  quickFilterBGColor: '#11161C',
  routeLockBGColor: '#223f5c',
  headColor: '#47a9f6',
  statusHeadFontColor: '#263955',
  statusHeadBGColor: '#263955',
  proNumbers: "#47a9f6",
  mapPopupFooter: "525F6D",
  maintenanceBGColor: "#01112a",
  btnHoverColor: "#1B283B",
  stopListCardStatusBar: '#363D50',
  gridOverlayBGColor: "#10141D",
  gridOverlayFontColor: "#FFFFFF",
  //marker colors start----
  markerStokeColor: "#081514",
  newPickupFillColor: "#29B6F6",
  missedVoidedPickupFillColor: "#F76E64",
  pickupStatusFillColors: "#3B9F9D",
  driverStatusMarkerColor: "#47A9F6",
  //marker colors end------
  recommendationKPIBorder: "#505769",
  quickFilterToggleButtonBorder: "#7D7D7E",
  dividerColorSecondary: "#666666",
  violationColor: "#F76E64",
  actionableTextColor: "#47a9f6",
}

const overrides = {
  dateTimePicker: {
    MuiPickersModal: {
      dialogRoot: {
        backgroundColor: modernDarkThemeStyles.ModalBGColor
      }
    },
    MuiPickersYear: {
      root: {
        color: modernDarkThemeStyles.white,
        '&:hover': {
          color: modernDarkThemeStyles.palette.primary.main
        },
        '&$selected': {
          color: modernDarkThemeStyles.palette.primary.main,
        },
        '&$disabled': {
          color: modernDarkThemeStyles.disabledColor,
          opacity: 0.5
        }
      },
      selected: {},
      disabled: {}
    },
    MuiPickersDay: {
      day: {
        color: modernDarkThemeStyles.white
      },
      isDisabled: {
        color: modernDarkThemeStyles.radioDisabledText
      }
    },
    MuiPickersSlideTransition: {
      transitionContainer: {
        '& > *': {
          color: modernDarkThemeStyles.white
        }
      }
    },
    MuiPickersCalendarHeader: {
      dayLabel: {
        color: modernDarkThemeStyles.white
      },
      iconButton: {
        backgroundColor: 'transparent',
        '& > *': {
          backgroundColor: 'transparent',
          color: modernDarkThemeStyles.white
        }
      }
    },
    MuiPickersClockNumber: {
      clockNumber: {
        color: modernDarkThemeStyles.white
      }
    }
  },
  CustomTextField: {
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: modernDarkThemeStyles.palette.primary.main,
          opacity: 1
        }
      },
      focused: {}
    }
  }
};

const overridesLightTheme = {
  CustomTextField: {
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: modernLightThemeStyles.palette.primary.main,
          opacity: 1
        }
      },
      focused: {}
    }
  }
};

modernDarkThemeStyles.overrides = {
  ...defaultThemeStyles.overrides,
  ...overrides.dateTimePicker,
  ...overrides.CustomTextField
};
modernLightThemeStyles.overrides = {
  ...defaultThemeStyles.overrides,
  ...overridesLightTheme.CustomTextField
};
const themes = {
  modernLight: createMuiTheme(modernLightThemeStyles),
  modernDark: createMuiTheme(modernDarkThemeStyles)
};
export default themes;